import React from "react";

import { Benefit } from "../types/Benefit";

const KeyBenefits = ({ benefits }: { benefits: Benefit[] }) => {
    return (
        <div className="w-full">
            {/* Title Section */}
            <div className="text-center mb-8">
                <h2 className="text-[#333333] dark:text-white text-3xl md:text-5xl font-semibold font-satoshi uppercase mb-12 leading-tight text-center">
                    Key Benefits
                </h2>
            </div>

            {/* Cards Container */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:auto-rows-auto">
                {benefits.map((benefit, index) => (
                    <div
                        key={index}
                        className={`flex flex-col rounded-2xl pb-4 pt-4 pl-4 pr-2 md:pl-6 md:pr-4 ${benefit.bgColor} ${
                            benefit.bgColor === "bg-[#fff9fd]"
                                ? "dark:bg-purple-900/20"
                                : benefit.bgColor === "bg-[#fff2e4]"
                                  ? "dark:bg-amber-900/20"
                                  : benefit.bgColor === "bg-[#fae9e4]"
                                    ? "dark:bg-orange-900/20"
                                    : benefit.bgColor === "bg-[#f9f5f4]"
                                      ? "dark:bg-gray-700/70"
                                      : benefit.bgColor === "bg-[#eaf2ff]"
                                        ? "dark:bg-blue-900/20"
                                        : "dark:bg-gray-700"
                        } relative overflow-hidden`}
                        style={{
                            height: "auto", // Let the card height auto-adjust to content on mobile
                        }}
                    >
                        {/* Content container */}
                        <div className="flex flex-col h-full">
                            {/* Title and Icon Row */}
                            <div className="flex justify-between items-start md:mb-4">
                                {/* Title */}
                                <div className="text-[#333333] dark:text-white text-2xl md:text-3xl lg:text-4xl font-medium font-satoshi leading-tight whitespace-pre-line max-w-[60%] mb-3">
                                    {benefit.title}
                                </div>

                                {/* Icon container */}
                                <div className="w-20 h-20 md:w-28 md:h-28 shrink-0 overflow-hidden">
                                    {benefit.icon && (
                                        <div className="w-full h-full flex items-center justify-center">
                                            <benefit.icon className="max-w-full max-h-full object-contain" />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Description */}
                            <div className="text-base font-space leading-snug md:mt-4">
                                {benefit.description.map((segment, idx) =>
                                    segment.type === "highlight" &&
                                    segment.url ? (
                                        <a
                                            key={idx}
                                            href={segment.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-[#1a5b77] dark:text-blue-300 font-normal underline"
                                        >
                                            {segment.text}
                                        </a>
                                    ) : (
                                        <span
                                            key={idx}
                                            className={
                                                segment.type === "highlight"
                                                    ? "text-[#1a5b77] dark:text-blue-300 font-normal underline"
                                                    : "text-[#333333] dark:text-gray-200 font-light"
                                            }
                                        >
                                            {segment.text}
                                        </span>
                                    ),
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default KeyBenefits;
